module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderReport.selectAuth) ? _c('div', {
    attrs: {
      "id": "orderReport"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "mainIframe",
      "name": "mainIframe",
      "width": "100%",
      "height": "1000px",
      "src": "https://me.bdp.cn/share/index.html?shareId=sdo_4e0b54a32fb356a25954777b78634c11",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-1c9d4e83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finreport/orderReport.vue
// module id = 1605
// module chunks = 0